export default {
  computed: {
    defaultUnsetImage() {
      return 'https://w7.pngwing.com/pngs/753/432/png-transparent-user-profile-2018-in-sight-user-conference-expo-business-default-business-angle-service-people-thumbnail.png';
    },
  },
};
